import { CartesianGrid, Legend, Line, LineChart, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { CustomizedYAxisLabel } from 'domain/shared/core/chart';
import React from 'react';
import { Box, Typography, SxProps } from '@mui/material';
import { foundationColors } from 'framework/ui/themes';

interface CPITrendsChartProps {
  data: any[];
  sx?: SxProps;
}

const CPITrendsChart: React.FC<CPITrendsChartProps> = ({ data, sx }) => {
  return (
    <Box
      sx={{
        width: '50%',
        height: '400px',
        backgroundColor: 'background.paper',
        alignItems: 'center',
        borderRadius: 1,
        ...sx,
      }}
    >
      <Box my={1} sx={{ alignItems: 'center', width: '100%', display: 'flex', justifyContent: 'center' }}>
        <Typography variant="h5">CPI Trends</Typography>
      </Box>
      <ResponsiveContainer width="100%" height="100%">
        <LineChart data={data} margin={{ top: 20, right: 30, left: 20, bottom: 20 }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis tick={{ fontSize: 12 }} dataKey="statusUpdate" padding={{ left: 30, right: 30 }} />
          <YAxis tick={{ fontSize: 12 }} label={<CustomizedYAxisLabel label="Index" />} />
          <Tooltip />
          <Line
            type="monotone"
            dataKey="cpiBudget"
            name="CPI (Budget)"
            stroke={foundationColors.primary}
            strokeWidth={2}
            dot={{ r: 4 }}
          />
          <Line
            type="monotone"
            dataKey="cpiTimeline"
            name="CPI (Timeline)"
            stroke={foundationColors.secondaryAccent}
            strokeWidth={2}
            dot={{ r: 4 }}
          />
          <Legend />
        </LineChart>
      </ResponsiveContainer>
    </Box>
  );
};

export default CPITrendsChart;
